/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DemographicProfile from '../components/QuickReports/DemographicProfile';
import Segmentation from '../components/QuickReports/Segmentation';
import MediaPlatformActivity from '../components/QuickReports/MediaPlatformActivity';
import MediaActivityPlatform from '../components/QuickReports/MediaActivityPlatform';
import QuickReportsDropdown from '../components/QuickReports/QuickReportsDropdown';
import TimeSpent from '../components/QuickReports/TimeSpent';
import IncrementalReach from '../components/QuickReports/IncrementalReach';
import { REPORT_TYPES_MAPPED, DYNAMIC_REPORT_TYPES } from '../util/QuickReportsUtils';
import { numberWithCommas, checkWeightType } from '../util/CommonUtils';
import SimultaneousUsage from '../components/QuickReports/SimultaneousUsage';
import SocialMediaActivityProfile from '../components/QuickReports/SocialMediaActivityProfile';
import ReachQuickReport from '../components/QuickReports/ReachQuickReport';
import DigitalActivityProfile from '../components/QuickReports/DigitalActivityProfile';
import DayInLife from '../components/QuickReports/DayInLife';
import ChannelCategory from '../components/QuickReports/ChannelCategory';
import WebsiteVisitation from '../components/QuickReports/WebsiteVisitation';
import StudyFootnotes from '../components/common/StudyFootnotes/StudyFootnotes';
import * as quickReportsActions from '../actions/quickReportsActions';
import { DDNHCS_FOOTER_NOTE } from '../messages/ReportsMessages';
import { QUICKREPORT_RUN_REPORT } from '../constants';
import Maps from '../components/QuickReports/Maps/Maps';

class QuickReportsViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: ' ',
      reportResult: this.props.reportResult,
      subTitle: '',
      footer: '',
    };
    this.QuickReportsDropdown = React.createRef();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.reportResult !== nextProps.reportResult) {
      this.setState({ reportResult: nextProps.reportResult });
    }
  }

  handletitle = (title, subTitle = '') => this.setState({ title, subTitle });

  handleFooter = (footer = '') => this.setState({ footer });

  handleExportParamsFromComponent = (
    option = undefined,
    subType = undefined,
    combos = undefined,
    remove,
    incrementalReach = undefined,
    categoryCount = undefined,
  ) => {
    this.props.quickReportsActions.addExportQuickReportsParmstoRedux({
      option,
      subType,
      remove: remove ? [...remove] : undefined,
      combos: combos ? [...combos] : undefined,
      incrementalReach: incrementalReach ? [...incrementalReach] : undefined,
      categoryCount,
    });
  };

  callTrackerFn = subModule => {
    this.props.trackerFn({ action: QUICKREPORT_RUN_REPORT, subModule: subModule.subModule });
  }

  checkDDNHCS() {
    const data = this.state.reportResult.headers;
    let ddNHCS = false;

    const { selectedQuickReportsKPIsTitle, allSelectedQuickReportsKPIsInfo } = this.props;

    for (const key in selectedQuickReportsKPIsTitle) {
      if (
        selectedQuickReportsKPIsTitle[key] === data[0].label
        && allSelectedQuickReportsKPIsInfo[key]
        && allSelectedQuickReportsKPIsInfo[key].modeled
      ) {
        ddNHCS = true;
      }

      if (
        selectedQuickReportsKPIsTitle[key] === data[1].label
        && allSelectedQuickReportsKPIsInfo[key]
        && allSelectedQuickReportsKPIsInfo[key].modeled
      ) {
        ddNHCS = true;
      }
    }
    return ddNHCS;
  }

  renderReport = reportName => {
    const report = DYNAMIC_REPORT_TYPES[reportName]
      ? DYNAMIC_REPORT_TYPES[reportName]
      : reportName;
    switch (report) {
      case REPORT_TYPES_MAPPED.DEMOPROFILE:
        return (
          <DemographicProfile
            data={this.state.reportResult.detailGroups}
            handletitle={this.handletitle}
            handleExportParams={this.handleExportParamsFromComponent}
            trackerFn={this.callTrackerFn}
            study={this.props.quickReportsStudy}
          />
        );
      case REPORT_TYPES_MAPPED.SEGMENTATION:
        return (
          <Segmentation
            data={this.state.reportResult.detailGroups}
            dropdown={this.state.reportResult.subReportDropdown}
            handletitle={this.handletitle}
            handleExportParams={this.handleExportParamsFromComponent}
            trackerFn={this.callTrackerFn}
            study={this.props.quickReportsStudy}
          />
        );
        case REPORT_TYPES_MAPPED.MAP:
          return (
            <Maps
              handletitle={this.handletitle}
              runReport={this.props.runReport}
            />
          );     
      case REPORT_TYPES_MAPPED.SIM:
        return (
          <SimultaneousUsage
            data={this.state.reportResult.detailGroups}
            handletitle={this.handletitle}
            handleExportParams={this.handleExportParamsFromComponent}
            trackerFn={this.callTrackerFn}
            study={this.props.quickReportsStudy}
          />
        );
      case REPORT_TYPES_MAPPED.SMAP:
        return (
          <SocialMediaActivityProfile
            data={this.state.reportResult.detailGroups}
            subTitleLabel={this.state.reportResult.headers[1].label}
            handletitle={this.handletitle}
            handleExportParams={this.handleExportParamsFromComponent}
            trackerFn={this.callTrackerFn}
            study={this.props.quickReportsStudy}
          />
        );
      case REPORT_TYPES_MAPPED.MAAP:
        return (
          <MediaActivityPlatform
            data={this.state.reportResult.detailGroups}
            dropdown={this.state.reportResult.subReportDropdown}
            dropdownWindow={this.QuickReportsDropdown}
            handletitle={this.handletitle}
            handleFooter={this.handleFooter}
            handleExportParams={this.handleExportParamsFromComponent}
            runReport={this.props.runReport}
            trackerFn={this.callTrackerFn}
            study={this.props.quickReportsStudy}
          />
        );
      case REPORT_TYPES_MAPPED.TIMESPENT:
        return (
          <TimeSpent
            data={this.state.reportResult.detailGroups}
            dropdown={this.state.reportResult.subReportDropdown}
            dropdownWindow={this.QuickReportsDropdown}
            handletitle={this.handletitle}
            handleExportParams={this.handleExportParamsFromComponent}
            runReport={this.props.runReport}
            trackerFn={this.callTrackerFn}
            study={this.props.quickReportsStudy}
          />
        );
      case REPORT_TYPES_MAPPED.MPAA:
        return (
          <MediaPlatformActivity
            data={this.state.reportResult.detailGroups}
            dropdown={this.state.reportResult.subReportDropdown}
            dropdownWindow={this.QuickReportsDropdown}
            handletitle={this.handletitle}
            handleFooter={this.handleFooter}
            handleExportParams={this.handleExportParamsFromComponent}
            runReport={this.props.runReport}
            trackerFn={this.callTrackerFn}
            study={this.props.quickReportsStudy}
            runReportFlag={this.props.runReportFlag}
          />
        );
      case REPORT_TYPES_MAPPED.REACH:
        return (
          <ReachQuickReport
            data={this.state.reportResult.detailGroups}
            dropdown={this.state.reportResult.subReportDropdown}
            dropdownWindow={this.QuickReportsDropdown}
            handletitle={this.handletitle}
            handleExportParams={this.handleExportParamsFromComponent}
            runReport={this.props.runReport}
            trackerFn={this.callTrackerFn}
            study={this.props.quickReportsStudy}
          />
        );
      case REPORT_TYPES_MAPPED.DIGITALACTIVITY:
        return (
          <DigitalActivityProfile
            data={this.state.reportResult.detailGroups}
            handletitle={this.handletitle}
            handleExportParams={this.handleExportParamsFromComponent}
            trackerFn={this.callTrackerFn}
            study={this.props.quickReportsStudy}
          />
        );
      case REPORT_TYPES_MAPPED.DAYLIFE:
        return (
          <DayInLife
            data={this.state.reportResult.detailGroups}
            handletitle={this.handletitle}
            handleFooter={this.handleFooter}
            handleExportParams={this.handleExportParamsFromComponent}
            runReport={this.props.runReport}
            trackerFn={this.callTrackerFn}
            study={this.props.quickReportsStudy}
          />
        );
      case REPORT_TYPES_MAPPED.CHANCAT:
        return (
          <ChannelCategory
            data={this.state.reportResult.detailGroups}
            handletitle={this.handletitle}
            runReport={this.props.runReport}
            handleExportParams={this.handleExportParamsFromComponent}
            reportName={this.state.reportResult.reportName}
            trackerFn={this.callTrackerFn}
            study={this.props.quickReportsStudy}
          />
        );
      case REPORT_TYPES_MAPPED.IREACH:
        return (
          <IncrementalReach
            data={this.state.reportResult.detailGroups}
            handletitle={this.handletitle}
            reportName={this.state.reportResult.reportName}
            handleExportParams={this.handleExportParamsFromComponent}
            runReport={this.props.runReport}
            trackerFn={this.callTrackerFn}
            study={this.props.quickReportsStudy}
          />
        );
      case REPORT_TYPES_MAPPED.WEBVIS:
        return (
          <WebsiteVisitation
            data={this.state.reportResult.detailGroups}
            handletitle={this.handletitle}
            reportName={this.state.reportResult.reportName}
            handleExportParams={this.handleExportParamsFromComponent}
            runReport={this.props.runReport}
            trackerFn={this.callTrackerFn}
            study={this.props.quickReportsStudy}
          />
        );
      default:
        return <div />;
    }
  };

  renderReportHeader = data => {
    let label = data[0].label;
    let label1 = data[1].label;

    const { selectedQuickReportsKPIsTitle, allSelectedQuickReportsKPIsInfo } = this.props;

    for (const key in selectedQuickReportsKPIsTitle) {
      if (
        selectedQuickReportsKPIsTitle[key] === label
        && allSelectedQuickReportsKPIsInfo[key]
        && allSelectedQuickReportsKPIsInfo[key].modeled
      ) {
        label = `${String.fromCharCode(10020)} ${label}`;
      }

      if (
        selectedQuickReportsKPIsTitle[key] === label1
        && allSelectedQuickReportsKPIsInfo[key]
        && allSelectedQuickReportsKPIsInfo[key].modeled
      ) {
        label1 = `${String.fromCharCode(10020)} ${label1}`;
      }
    }

    return (
      <div className="row expanded">
        <div className="large-6 column" style={{ paddingRight: '10px' }}>
          <table className="base-target-table">
            <thead>
              <tr>
                <th>Base Name</th>
                <th>Sample</th>
                <th>Weighted {checkWeightType(this.props.quickreportsWeightTypes)}</th>
                <th>Percentage</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td title={data[0].label}>{label}</td>
                <td title={numberWithCommas(data[0].sample)}>{numberWithCommas(data[0].sample)}</td>
                <td title={numberWithCommas(data[0].weighted)}>{numberWithCommas(data[0].weighted)}</td>
                <td title={data[0].pct}>{data[0].pct}%</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="large-6 column" style={{ paddingLeft: '10px' }}>
          <table className="base-target-table">
            <thead>
              <tr>
                <th>Target Name</th>
                <th>Sample</th>
                <th>Weighted {checkWeightType(this.props.quickreportsWeightTypes)}</th>
                <th>Percentage</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td title={data[1].label}>{label1}</td>
                <td title={numberWithCommas(data[1].sample)}>{numberWithCommas(data[1].sample)}</td>
                <td title={numberWithCommas(data[1].weighted)}>{numberWithCommas(data[1].weighted)}</td>
                <td title={data[1].pct}>{data[1].pct}%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  renderReportViewer = () => {
    if (!this.state.reportResult) {
      return <div />;
    }
    return (
      <div
        className="quickreport-body"
        style={{ paddingLeft: 0, paddingRight: 0 }}
      >
        <div
          className="column large-12 smart-search-editor"
          style={{ paddingTop: 0, paddingBottom: 0 }}
        >
          <h4 className="quick-report-title margin-top-0">
            <div className="large-8 column padding-0">
              <span className="header-textqr" title={this.state.title}>
                {this.state.title}
                <span
                  title={this.state.subTitle ? `(${this.state.subTitle})` : ''}
                >
                  &nbsp;{this.state.subTitle ? `(${this.state.subTitle})` : ''}
                </span>
              </span>
            </div>
            <div className="large-4 column padding-0">
              <button
                type="button"
                onClick={() => {
                  this.props.quickReportsClear();
                  this.props.toggleQuickReportView(false);
                }}
                className="clear-all-report float-right"
              >
                Clear All
              </button>
              <button
                type="button"
                onClick={() => {
                  this.props.quickReportsActions.clearWeightType();
                  this.props.toggleQuickReportView(false);
                  this.props.quickReportsActions.setQuickReportRunFlag(true);
                }}
                className="back-to-dashboard float-right"
              >
                Dashboard
              </button>
            </div>
          </h4>
        </div>
        <div className="quickreport-viewer-body">
          {this.renderReportHeader(this.state.reportResult.headers)}
          {this.state.reportResult &&
          this.state.reportResult.detailGroups &&
          Object.keys(this.state.reportResult.detailGroups).length !== 0
            ? this.renderReport(this.state.reportResult.reportName)
            : this.state.reportResult.reportName === 'MAP'
            ? this.renderReport(this.state.reportResult.reportName)
            : this.props.showValidate()}
          <div
            className={`quick-report-common-asterisks
              ${
              this.state.reportResult.reportName === 'DAP' ||
                this.state.reportResult.reportName === 'MAAP' ||
                this.state.reportResult.reportName === 'MPAA'
                ? ' dap-asterisk maap-asterisk'
                : ''
              }`}
          >
            <StudyFootnotes
              studyList={this.props.studyList}
              selectedStudy={this.props.selectedStudy}
              className={`${(this.state.reportResult.reportName === 'SMAP')
                && 'qcReport-footnote'} text-right font-12 `}
            />
            <div
              className="text-right font-12"
              style={{
                marginTop: `${this.state.reportResult.reportName === 'DEMOPROFILE' ? '-34px' : ''}`,
                paddingTop: 2,
              }}
            >
              {this.props.quickReportsStudy && this.state.reportResult.reportName === 'DEMOPROFILE'
                && this.checkDDNHCS() ? DDNHCS_FOOTER_NOTE : ''}
            </div>
            <div className="text-right font-12">
              {this.state.reportResult.reportName === 'DAP'
                ? '*Camera, Email, Listen to Music, Talk, Messaging and Video excluded activity behaviors from iOS8 devices and greater.'
                : ''}
            </div>
            <div className="text-right font-12">{this.state.footer}</div>
          </div>
          {this.state.reportResult.reportName === 'SMAP' ? (
            <div className="text-right text-italic font-12 float-right large-6 medium-5">
            ‡ Among target social media users who selected any visitation
            frequency for social media websites
            </div>
          ) : (
              ''
            )}
          <QuickReportsDropdown
            ref={this.QuickReportsDropdown}
          />
        </div>
      </div>
    );
  };

  render() {
    return (
      <div>
        {this.renderReportViewer()}
      </div>
    );
  }
}

QuickReportsViewer.propTypes = {
  quickReportsStudy: PropTypes.shape({}),
  quickReportsActions: PropTypes.shape({
    clearWeightType: PropTypes.func,
    addExportQuickReportsParmstoRedux: PropTypes.func,
  }),
  reportResult: PropTypes.shape({}),
  runReport: PropTypes.func,
  quickReportsClear: PropTypes.func,
  toggleQuickReportView: PropTypes.func,
  allSelectedQuickReportsKPIsInfo: PropTypes.shape({}),
  selectedQuickReportsKPIsTitle: PropTypes.shape({}),
  trackerFn: PropTypes.func,
  selectedStudy: PropTypes.shape({}),
  studyList: PropTypes.arrayOf(PropTypes.object),
  quickreportsWeightTypes: PropTypes.shape({}),
  showValidate: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    reportResult: state.quickReports.reportResult,
    selectedQuickReportsKPIsTitle: state.quickReports.selectedQuickReportsKPIsTitle,
    allSelectedQuickReportsKPIsInfo: state.quickReports.allSelectedQuickReportsKPIsInfo,
    selectedStudy: state.study.quickReportsStudy,
    studyList: state.study.studies,
    quickreportsWeightTypes: state.study.quickreportsWeightTypes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    quickReportsActions: bindActionCreators(quickReportsActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(QuickReportsViewer);
